import React from "react";
import { Outlet } from "react-router-dom";
import "./desktop-layout.css";
import DesktopMenu from "../DesktopMenu";
import { Context } from "../../context/ContextProvider/ContextProvider";

const DesktopLayout = () => {
  const { showDesktopMenu } = React.useContext(Context);

  return (
    <div className="w-100 flex" style={{ position: "relative" }}>
      <DesktopMenu />
      <div
        className={`outlet-container border-box vh-100 scroll ${
          showDesktopMenu ? "" : "collapsed"
        }`}
        style={{
          backgroundColor: "white",
          position: "fixed",
          right: 0,
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default DesktopLayout;
